<template>
  <div class="login">
    <van-cell-group>
      <van-field clearable type="tel" label="手机号" maxlength="11" v-model="postForm.mobile" placeholder="请输入手机号" />
      <van-field type="password" label="密码" v-model="postForm.password" placeholder="请输入密码" />
    </van-cell-group>
    <bottom-btn class="mt15" title="保存" :fixed="false" @click.native="handleLogin" />
  </div>
</template>

<script>
import { Field, CellGroup, Toast } from 'vant'
import BottomBtn from '@/components/BottomBtn'
import { validatePhone } from '@/utils/validation'

export default {
  name: 'Login',
  components: {
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    BottomBtn
  },
  data () {
    return {
      postForm: {
        mobile: '',
        password: ''
      },
      redirect: undefined
    }
  },
  created () {
    this.redirect = this.$route.query.redirect || undefined
  },
  methods: {
    async handleLogin () {
      if (!this.postForm.mobile) {
        Toast('请输入手机号')
        return false
      }
      if (!validatePhone(this.postForm.mobile)) {
        Toast('手机号有误')
        return false
      }
      if (!this.postForm.password) {
        Toast('请输入密码')
        return false
      }
      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      await this.$store.dispatch('LoginByMobile', this.postForm)
      Toast.clear()
      this.$router.push({ path: this.redirect || '/' })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
